module.exports = __webpack_public_path__ + "img/ph.phaf9d4fe.svg";